import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ErrandType } from '../../../../app/round-planning/model/const/enums';
import { Errand } from '../../../../app/round-planning/model/errand';
import { Command, CommandBase, standardCommand } from '../../model/command';
import { ModelBase } from '../../model/model-base';
import { NavigationService } from '../navigation.service';
import { ICommandHandler } from './command-handler-resolver.service';

@Injectable()
export class EditCommandHandler<TContext extends { id: string } = ModelBase> implements ICommandHandler {
  constructor(private readonly _navigation: NavigationService) {}

  canExecute(command: CommandBase): boolean {
    return (command as Command)?.context && command.id == standardCommand.edit;
  }

  execute(command: Command<TContext>): Observable<void> {
    if (command.context instanceof ModelBase) {
      command.context.storeRecentId?.(); // so we can highlight it when the user navigates back
      if (command.context instanceof Errand) {
        switch (command.context.type) {
          case ErrandType.AuthorityInspection:
            this._navigation.navigate(['errands', 'authority-inspection', 'edit', command.context.id]);
            break;
          case ErrandType.Deviation:
            this._navigation.navigate(['errands', 'rounding', 'edit', command.context.id]);
            break;
          default:
            console.error('Unknown errand type: ' + command.context.type);
            break;
        }

        return of(null);
      }
    }
    return of(this._navigation.navigateToForm(command.context.id));
  }
}
